import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
declare var bootbox:any;
declare var $:any;
@Component({
  selector: 'undefined-email-queue',
  template: require('./email-queue.component.html'),
  styles: [require('./email-queue.component.css')]
})
export class EmailQueueComponent extends BaseComponent implements OnInit {

  public modalBusy: Subscription;

  public queuedEmails = [];

  public selectedOrganizationId = -1;
  public selectedManagerId = -1;

  public organisations = [];
  public managers = [];

  public selectedQueueEmails = [];

  public updateSelectedQueueEmailsFromEmails() {
    if(this.selectedQueueEmails == null || this.selectedQueueEmails.length <= 0)
      return;
    var found = false;
    for(var i=0;i<this.queuedEmails.length;i++) {
      var emails = this.queuedEmails[i];
      for(var k=0;k<emails.length;k++) {
        var email = emails[k];
        if(email.tipsEmailQueueId == this.selectedQueueEmails[0].tipsEmailQueueId) {
          this.selectedQueueEmails = emails;
          found = true;
          break;
        }
      }
      if(found)
        break;
    }
  }

  public getDepartment(mgr) {
    if(mgr.department!=null)
      return " (" + mgr.department.name + " - " + mgr.email + ")";
    else
      return "";
  }

  public loadQueuedEmails() {
    this.modalBusy = this.busy = this.lsApi.getQueuedEmailsForListing(this.selectedOrganizationId, this.selectedManagerId).subscribe(resp => {
        if(resp.status) {
            this.queuedEmails = resp.data;
            this.updateSelectedQueueEmailsFromEmails();
        }
    },
    error => {
        console.log(error);
    });
  }

  public organizationSelectionChanged() {
    this.selectedManagerId = -1;
    this.loadOrganizationManagers();
  }

  public getQueuedCount(email) {
    if(email.length<=0) {
      return "N/A";
    }
    return email.length;
  }

  public getNextSentOn(email) {
    if(email.length<=0) {
      return "N/A";
    }
    email.sort(function(a, b){return a.categoryIndex - b.categoryIndex});
    var nextOn = null;
    for(var i=0;i<email.length;i++) {
      var e = email[i];
      if(e.sentOn == null) {
        if(nextOn==null)
          nextOn = e.queuedFor;
        if(Date.parse(nextOn) > Date.parse(e.queuedFor))
          nextOn = e.queuedFor;
      }
    }
    return nextOn;
  }

  public getLastSentOn(email) {
    if(email.length<=0) {
      return "N/A";
    }
    email.sort(function(a, b){return a.categoryIndex - b.categoryIndex});
    var sentOn = null;
    for(var i=0;i<email.length;i++) {
      var e = email[i];
      if(e.sentOn == null) {
        break;
      }
      else {
        if(sentOn==null)
          sentOn = e.sentOn;
        if(Date.parse(sentOn) < Date.parse(e.sentOn))
          sentOn = e.sentOn;
      }
    }
    return sentOn;
  }

  public getLastSentOnState(email) {
    if(email.length<=0) {
      return "N/A";
    }
    email.sort(function(a, b){return a.categoryIndex - b.categoryIndex});
    var isSent = null;
    for(var i=0;i<email.length;i++) {
      var e = email[i];
      if(e.sentOn == null) {
        break;
      }
      else {
        isSent = e.isSent;
      }
    }
    return isSent;
  }

  public getSurveyDetails(email) {
    if(email.length<=0) {
      return "N/A";
    }
    var emailFirst = email[0];
    var output = '<b>' + emailFirst.surveyTitle + '</b> <br><small>' + emailFirst.batchNumber + '</small>';
    return output;
  }

  public getManagerDetails(email) { 
    if(email.length<=0) {
      return "N/A";
    }
    var emailFirst = email[0];
    var output = emailFirst.manager.firstname + " " + emailFirst.manager.lastname + "<br><small>" + emailFirst.manager.email + "<br>" + emailFirst.manager.organization.name + "</small>";
    return output;
  }


  public loadOrganizations() {
    this.busy = this.lsApi.getOrganizationsForSelect().subscribe(resp => {
        if(resp.status) {
            this.organisations = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }

  public viewDetails(email) {
    this.selectedQueueEmails = email;
    this.selectedQueueEmails.sort(function(a, b){return a.categoryIndex - b.categoryIndex});
    $("#tipEmailDetails").modal('show');
  }


  public loadOrganizationManagers() {
    this.busy = this.lsApi.getOrganizationManagersForSelect(this.selectedOrganizationId, -1).subscribe(resp => {
        if(resp.status) {
            this.managers = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadOrganizations();
    this.loadQueuedEmails();
  }

  public dontSendEmail(id) {

    bootbox.confirm({message:"Do you want to remove this email from queue?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.dontSendQueuedEmail(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Email Successfully Removed From Queue","Report Email");
                this.loadQueuedEmails();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }


  public queueEmail(id) {

    bootbox.confirm({message:"Do you want to re-queue this email?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.queueTipEmailAgain(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Email Successfully Re-queued","Report Email");
                this.loadQueuedEmails();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

  public addSendEmail(id) {

    bootbox.confirm({message:"Do you want to add this email to queue?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.addSendQueuedEmail(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Email Successfully Added To Queue","Report Email");
                this.loadQueuedEmails();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

  public manuallySendEmail(id) {

    bootbox.confirm({message:"Do you want to send this email manually?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.manuallySendQueuedEmail(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Email Successfully Sent","Report Email");
                this.loadQueuedEmails();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

  public manuallySendEmailForceTest(id) {

    bootbox.confirm({message:"Do you want to send this email manually for testing?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

            this.modalBusy = this.lsApi.manuallySendQueuedEmailForceTest(id).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Email Successfully Sent","Report Email");
                this.loadQueuedEmails();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/email-queue/email-queue.component.ts